import { useSelector } from 'react-redux';
import './commercial-description.css';

/**
 * NarrativeBar - Three-card summary section below the hero.
 * Shows "The Opportunity", "The Asset", "The Market" highlights.
 */
const NarrativeBar = () => {
  const pdpInitData = useSelector((state) => state.pdp?.pdpInitData);
  const narrativeData = pdpInitData?.propertySpecialDetails?.commercialPropertyAdditionalFeatures;

  // Default cards if no CMS data
  const defaultCards = [
    {
      icon: <img src="/assets/images/pdp/opportunity.png" alt="" style={{ width: 48, height: 48, objectFit: 'contain' }} />,
      title: 'The Opportunity',
      description: narrativeData?.opportunity || 'Value-add play with below-market rents in place.',
    },
    {
      icon: <img src="/assets/images/pdp/asset.png" alt="" style={{ width: 48, height: 48, objectFit: 'contain' }} />,
      title: 'The Asset',
      description: narrativeData?.asset || 'Recently renovated lobby; minimal near-term CapEx required.',
    },
    {
      icon: <img src="/assets/images/pdp/market.png" alt="" style={{ width: 48, height: 48, objectFit: 'contain' }} />,
      title: 'The Market',
      description: narrativeData?.market || 'Located in a high job-growth corridor.',
    },
  ];

  return (
    <div className="commercial-narrative">
      {defaultCards.map((card, index) => (
        <div key={index} className="commercial-narrative__card">
          <div className="commercial-narrative__card-icon">{card.icon}</div>
          <div className="commercial-narrative__card-content">
            <div className="commercial-narrative__card-title">{card.title}</div>
            <div className="commercial-narrative__card-desc">{card.description}</div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default NarrativeBar;
